import { z } from 'zod';
const roleEntitySchema = z.object({
    id: z.number(),
    name: z.string().min(1)
});
const roleEntityToCreateSchema = roleEntitySchema.omit({ id: true });
export { roleEntitySchema, roleEntityToCreateSchema };
//# sourceMappingURL=projects.role.model.js.map